import { AutocompleteInput, SelectInput, SimpleForm, TextInput, NumberInput, required } from 'react-admin';
import { voiceServices } from 'skylar-agent/VoiceService';
import { useWatch } from 'react-hook-form';
import { Typography } from '@mui/material';

const serviceChoices = Object.keys(voiceServices).map( v => ({ id: v, name: voiceServices[v].name }) );

const voiceSuggestionsByService = {};
Object.keys(voiceServices).forEach( v => {
	voiceSuggestionsByService[v] = voiceServices[v].handler.voiceOptions();
});

const customChoices = [];

const onCreate = (choice) => {
	const newChoice = { id: choice, name: choice };
	customChoices.push( newChoice );
	return newChoice;
};

const VoiceIdInput = () =>{
	const service = useWatch({ name: 'service' });
	const choices = customChoices.concat( service ? voiceSuggestionsByService[service] || [] : [] );

	return (
		<AutocompleteInput
			source="service_voice_id"
			label="Voice ID"
			validate={required()}
			choices={choices}
			onCreate={onCreate}
			createItemLabel={item => item}
		/>
	);
}

const ServiceSpecificOptions = () => {
	const service = useWatch({ name: 'service' });
	let Opt = <></>;

	switch( service ) {
		case 'azure':
			Opt = (
				<>
				<Typography>Azure Voice Settings</Typography>
				<NumberInput source="voice_options.pitch" label="Pitch %" defaultValue="0" fullWidth={false} />
				<NumberInput source="voice_options.rate" label="Rate %" defaultValue="0" fullWidth={false} />
				<NumberInput source="voice_options.volume" label="Volume %" defaultValue="100" fullWidth={false} />
				</>
			);

			break;
	}

	return Opt;
};

export const FormFields = (
	<SimpleForm>
		<TextInput source="name" validate={required()} />
		<SelectInput source="service" validate={required()} choices={serviceChoices} />
		<VoiceIdInput />
		<ServiceSpecificOptions />
	</SimpleForm>
);